export default "__VITE_ASSET__DLJQXQEc__"